// extracted by mini-css-extract-plugin
module.exports = {"toolbarRoot":"NavbarLogin_toolbarRoot__3DPcR","logoDiv":"NavbarLogin_logoDiv__3JhAV","logo":"NavbarLogin_logo__3d9qn"};